import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "chat-menu" }
const _hoisted_3 = { class: "d-inline account-icon-wrapper mb-8 ml-2" }
const _hoisted_4 = { class: "user-letter" }
const _hoisted_5 = { class: "username" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_tiem = _resolveComponent("v-list-tiem")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_Analysis = _resolveComponent("Analysis")!
  const _component_AnalysisExpanded = _resolveComponent("AnalysisExpanded")!
  const _component_ChatMessage = _resolveComponent("ChatMessage")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_AccountDialog = _resolveComponent("AccountDialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      (_ctx.isMobile)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            color: "primary",
            class: "mobile-nav-open",
            type: "submit",
            click: _ctx.toggleNav,
            buttonClass: "pa-0 mt-n16 ml-n1",
            icon: "mdi-menu-open",
            size: "x-large",
            density: "compact"
          }, null, 8, ["click"]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_navigation_drawer, {
        modelValue: _ctx.nav,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nav) = $event)),
        "expand-on-hover": "",
        rail: "",
        "rail-width": _ctx.navWidth,
        permanent: !_ctx.isMobile,
        temporary: _ctx.isMobile,
        width: 174
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, { class: "mb-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, { class: "pb-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    color: "primary",
                    class: "ml-2",
                    type: "submit",
                    click: _ctx.newChat,
                    buttonClass: "pa-0 ml-1",
                    icon: "mdi-note-plus-outline",
                    size: "x-large",
                    tooltip: _ctx.newChatLabel,
                    density: "compact"
                  }, null, 8, ["click", "tooltip"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_list, {
            class: "history-list overflow-y-auto",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    class: "history-list-filter mt-n6",
                    modelValue: _ctx.reportFilter,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reportFilter) = $event)),
                    name: "filter",
                    label: "Filter",
                    type: "text",
                    placeholder: "Filter",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "auto",
                    clearable: "",
                    "persistent-clear": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatsFiltered, ({ id, title, updatedAt }, index) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: _ctx.hash({ id, title, updatedAt, index })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "history-list-item" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "click history-list-title text-body-2",
                          onClick: ($event: any) => (_ctx.openChat(id))
                        }, _toDisplayString(title), 9, _hoisted_1),
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_v_tooltip, { location: "top" }, {
                            activator: _withCtx(({ props: tooltip }) => [
                              _createVNode(_component_v_icon, _mergeProps({ ref_for: true }, tooltip, {
                                onClick: ($event: any) => (_ctx.reanalyze(id)),
                                class: "chat-reanalyze click ml-4",
                                color: "primary"
                              }), {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                  _createTextVNode("mdi-refresh")
                                ])),
                                _: 2
                              }, 1040, ["onClick"])
                            ]),
                            default: _withCtx(() => [
                              _cache[5] || (_cache[5] = _createElementVNode("span", null, "Reanalyze", -1))
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_tooltip, { location: "top" }, {
                            activator: _withCtx(({ props: tooltip }) => [
                              _createVNode(_component_v_icon, _mergeProps({ ref_for: true }, tooltip, {
                                onClick: ($event: any) => (_ctx.deleteChat(id)),
                                class: "chat-delete click ml-4",
                                color: "primary"
                              }), {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                  _createTextVNode("mdi-delete-forever-outline")
                                ])),
                                _: 2
                              }, 1040, ["onClick"])
                            ]),
                            default: _withCtx(() => [
                              _cache[7] || (_cache[7] = _createElementVNode("span", null, "Delete", -1))
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_v_list, { class: "account-icon" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_tiem, null, {
                default: _withCtx(() => [
                  (!_ctx.subscriptionActive)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        variant: "plain",
                        class: "font-weight-black ml-0 shimmer-button",
                        slim: "",
                        color: "primary",
                        size: "x-large",
                        to: "/subscribe"
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createElementVNode("span", { class: "animate-text" }, [
                            _createElementVNode("span", null, "U"),
                            _createElementVNode("span", null, "P"),
                            _createElementVNode("span", null, "G"),
                            _createElementVNode("span", null, "R"),
                            _createElementVNode("span", null, "A"),
                            _createElementVNode("span", null, "D"),
                            _createElementVNode("span", null, "E")
                          ], -1)
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.isAdmin && !_ctx.demoModeDisplay)
                ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        variant: "plain",
                        class: "font-weight-black ml-n1",
                        slim: "",
                        color: "secondary",
                        size: "x-large",
                        to: "/admin",
                        icon: "mdi-account-cog-outline"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_list_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, [
                    _createVNode(_component_v_tooltip, { location: "top" }, {
                      activator: _withCtx(({ props: tooltip }) => [
                        _createElementVNode("div", _mergeProps({ class: "user-icon smaller click" }, tooltip, {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAccountDialog && _ctx.openAccountDialog(...args)))
                        }), [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.userLetter), 1)
                        ], 16)
                      ]),
                      default: _withCtx(() => [
                        _cache[9] || (_cache[9] = _createElementVNode("span", null, "Account", -1))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "rail-width", "permanent", "temporary"]),
      _createVNode(_component_v_row, {
        class: _normalizeClass(_ctx.isMobile ? 'mt-n6' : '')
      }, {
        default: _withCtx(() => [
          (!_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "1",
                class: "chat-history-container mt-0 pt-0"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: _ctx.isMobile ? 12 : 10,
            class: _normalizeClass(_ctx.isMobile ? 'mt-0 pt-0 smaller-text' : 'mt-0 pt-0')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.chat.length === 0 ? 'chat-context mt-n8' : 'chat-context expanded mt-n8')
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chat, ({ user, message }, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: _ctx.hash({ user, message, time: Date.now() }),
                    class: "my-4"
                  }, [
                    (index === 0)
                      ? (_openBlock(), _createBlock(_component_Analysis, {
                          key: 0,
                          id: _ctx.id,
                          showEvents: index === 0,
                          userMessage: user,
                          agentMessage: message,
                          timestamp: _ctx.timestamp
                        }, null, 8, ["id", "showEvents", "userMessage", "agentMessage", "timestamp"]))
                      : (index === 1)
                        ? (_openBlock(), _createBlock(_component_AnalysisExpanded, {
                            key: 1,
                            id: _ctx.id,
                            msg: message,
                            symbol: _ctx.title,
                            timestamp: _ctx.timestamp
                          }, null, 8, ["id", "msg", "symbol", "timestamp"]))
                        : (_openBlock(), _createBlock(_component_ChatMessage, {
                            key: 2,
                            id: _ctx.id,
                            userMessage: user,
                            agentMessage: message
                          }, null, 8, ["id", "userMessage", "agentMessage"]))
                  ]))
                }), 128))
              ], 2),
              (_ctx.chat.length === 0)
                ? (_openBlock(), _createElementBlock("h2", {
                    key: 0,
                    class: _normalizeClass(_ctx.isMobile ? 'chat-title text-h5 mb-8' : 'chat-title text-h4 mb-8')
                  }, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.usernameDisplay), 1),
                    _createTextVNode(_toDisplayString(_ctx.chatHeadline), 1)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.chat.length === 0)
                ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                    key: 1,
                    modelValue: _ctx.selectedStock,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedStock) = $event)),
                    items: _ctx.stocksList,
                    "menu-props": { maxWidth: 0 },
                    "item-title": "label",
                    "item-value": "symbol",
                    variant: "outlined",
                    label: "Select a stock",
                    clearable: "",
                    "persistent-clear": "",
                    class: "stock-selector"
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_v_tooltip, { location: "top" }, {
                        activator: _withCtx(({ props: tooltip }) => [
                          _createVNode(_component_v_icon, _mergeProps(tooltip, {
                            disabled: _ctx.sendDisabled,
                            onClick: _ctx.getAnalysis,
                            color: _ctx.sendDisabled ? 'surface' : 'primary',
                            icon: "mdi-send-variant-outline",
                            size: "x-large"
                          }), null, 16, ["disabled", "onClick", "color"])
                        ]),
                        default: _withCtx(() => [
                          _cache[10] || (_cache[10] = _createElementVNode("span", null, "Analyze", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "items"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["cols", "class"]),
          (!_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "1",
                class: "mt-0 pt-0"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_AccountDialog)
    ]),
    _: 1
  }))
}